import { AbstractControl, UntypedFormArray, UntypedFormGroup } from '@angular/forms';

export function markControlsDirty(formGroup: UntypedFormGroup | UntypedFormArray | AbstractControl): void {
    formGroup.markAsDirty();
    formGroup.updateValueAndValidity();
    if (formGroup instanceof UntypedFormArray || formGroup instanceof UntypedFormGroup) {
        for (const control of Object.values(formGroup.controls)) {
            markControlsDirty(control);
        }
    }
}
